import i18n from 'i18next';
import { schemas as adminSchemas } from '../api/zodios/admin';

export const ApplicationPermissions =
  adminSchemas.ApplicationPermissions.element.enum;

export type ApplicationPermission =
  (typeof ApplicationPermissions)[keyof typeof ApplicationPermissions];

export const ApplicationAccessLevels =
  adminSchemas.ApplicationAccessLevels.enum;

export type ApplicationAccessLevel =
  (typeof ApplicationAccessLevels)[keyof typeof ApplicationAccessLevels];

export const FocalPointRequiredPermissions =
  adminSchemas.FocalPointRequiredPermissions.element.enum;

export type FocalPointRequiredPermission =
  (typeof FocalPointRequiredPermissions)[keyof typeof FocalPointRequiredPermissions];

export const WorkflowNames = adminSchemas.WorkflowNames.element.enum;

export type WorkflowName = (typeof WorkflowNames)[keyof typeof WorkflowNames];

export const StepNames = adminSchemas.StepNames.element.enum;

export type StepName = (typeof StepNames)[keyof typeof StepNames];

export const UfList = [
  { value: 'AC', label: 'Acre' },
  { value: 'AL', label: 'Alagoas' },
  { value: 'AP', label: 'Amapá' },
  { value: 'AM', label: 'Amazonas' },
  { value: 'BA', label: 'Bahia' },
  { value: 'CE', label: 'Ceará' },
  { value: 'DF', label: 'Distrito Federal' },
  { value: 'ES', label: 'Espírito Santo' },
  { value: 'GO', label: 'Goiás' },
  { value: 'MA', label: 'Maranhão' },
  { value: 'MT', label: 'Mato Grosso' },
  { value: 'MS', label: 'Mato Grosso do Sul' },
  { value: 'MG', label: 'Minas Gerais' },
  { value: 'PA', label: 'Pará' },
  { value: 'PB', label: 'Paraíba' },
  { value: 'PR', label: 'Paraná' },
  { value: 'PE', label: 'Pernambuco' },
  { value: 'PI', label: 'Piauí' },
  { value: 'RJ', label: 'Rio de Janeiro' },
  { value: 'RN', label: 'Rio Grande do Norte' },
  { value: 'RS', label: 'Rio Grande do Sul' },
  { value: 'RO', label: 'Rondônia' },
  { value: 'RR', label: 'Roraima' },
  { value: 'SC', label: 'Santa Catarina' },
  { value: 'SP', label: 'São Paulo' },
  { value: 'SE', label: 'Sergipe' },
  { value: 'TO', label: 'Tocantins' },
];

export const BanksOfBrazil = [
  { value: '001', name: 'BANCO DO BRASIL' },
  { value: '341', name: 'ITAÚ' },
  { value: '104', name: 'CAIXA ECONÔMICA FEDERAL' },
  { value: '033', name: 'BANCO SANTANDER S.A.' },
  { value: '070', name: 'BRB - BANCO DE BRASÍLIA' },
  { value: '077', name: 'BANCO INTER' },
  { value: '237', name: 'BRADESCO' },
  { value: '745', name: 'CITIBANK' },
  { value: '422', name: 'BANCO SAFRA' },
  { value: '399', name: 'BANCO HSBC' },
  { value: '756', name: 'BANCOOB' },
  { value: '212', name: 'BANCO ORIGINAL' },
  { value: '002', name: 'BANCO CENTRAL DO BRASIL' },
  { value: '003', name: 'BANCO DA AMAZONIA S.A' },
  { value: '004', name: 'BANCO DO NORDESTE DO BRASIL S.A' },
  { value: '007', name: 'BANCO NAC DESENV. ECO. SOCIAL S.A' },
  { value: '008', name: 'BANCO MERIDIONAL DO BRASIL' },
  { value: '020', name: 'BANCO DO ESTADO DE ALAGOAS S.A' },
  { value: '021', name: 'BANCO DO ESTADO DO ESPIRITO SANTO S.A' },
  { value: '022', name: 'BANCO DE CREDITO REAL DE MINAS GERAIS SA' },
  { value: '024', name: 'BANCO DO ESTADO DE PERNAMBUCO' },
  { value: '025', name: 'BANCO ALFA S/A' },
  { value: '026', name: 'BANCO DO ESTADO DO ACRE S.A' },
  { value: '027', name: 'BANCO DO ESTADO DE SANTA CATARINA S.A' },
  { value: '028', name: 'BANCO DO ESTADO DA BAHIA S.A' },
  { value: '029', name: 'BANCO DO ESTADO DO RIO DE JANEIRO S.A' },
  { value: '030', name: 'BANCO DO ESTADO DA PARAIBA S.A' },
  { value: '031', name: 'BANCO DO ESTADO DE GOIAS S.A' },
  { value: '032', name: 'BANCO DO ESTADO DO MATO GROSSO S.A.' },
  { value: '034', name: 'BANCO DO ESADO DO AMAZONAS S.A' },
  { value: '035', name: 'BANCO DO ESTADO DO CEARA S.A' },
  { value: '036', name: 'BANCO DO ESTADO DO MARANHAO S.A' },
  { value: '037', name: 'BANCO DO ESTADO DO PARA S.A' },
  { value: '038', name: 'BANCO DO ESTADO DO PARANA S.A' },
  { value: '039', name: 'BANCO DO ESTADO DO PIAUI S.A' },
  { value: '041', name: 'BANCO DO ESTADO DO RIO GRANDE DO SUL S.A' },
  { value: '047', name: 'BANCO DO ESTADO DE SERGIPE S.A' },
  { value: '048', name: 'BANCO DO ESTADO DE MINAS GERAIS S.A' },
  { value: '059', name: 'BANCO DO ESTADO DE RONDONIA S.A' },
  { value: '106', name: 'BANCO ITABANCO S.A.' },
  { value: '107', name: 'BANCO BBM S.A' },
  { value: '109', name: 'BANCO CREDIBANCO S.A' },
  { value: '116', name: 'BANCO B.N.L DO BRASIL S.A' },
  { value: '148', name: 'MULTI BANCO S.A' },
  { value: '151', name: 'CAIXA ECONOMICA DO ESTADO DE SAO PAULO' },
  { value: '153', name: 'CAIXA ECONOMICA DO ESTADO DO R.G.SUL' },
  { value: '165', name: 'BANCO NORCHEM S.A' },
  { value: '166', name: 'BANCO INTER-ATLANTICO S.A' },
  { value: '168', name: 'BANCO C.C.F. BRASIL S.A' },
  { value: '175', name: 'CONTINENTAL BANCO S.A' },
  { value: '184', name: 'BBA - CREDITANSTALT S.A' },
  { value: '199', name: 'BANCO FINANCIAL PORTUGUES' },
  { value: '200', name: 'BANCO FRICRISA AXELRUD S.A' },
  { value: '201', name: 'BANCO AUGUSTA INDUSTRIA E COMERCIAL S.A' },
  { value: '204', name: 'BANCO S.R.L S.A' },
  { value: '205', name: 'BANCO SUL AMERICA S.A' },
  { value: '206', name: 'BANCO MARTINELLI S.A' },
  { value: '208', name: 'BANCO PACTUAL S.A' },
  { value: '210', name: 'DEUTSCH SUDAMERIKANICHE BANK AG' },
  { value: '211', name: 'BANCO SISTEMA S.A' },
  { value: '213', name: 'BANCO ARBI S.A' },
  { value: '214', name: 'BANCO DIBENS S.A' },
  { value: '215', name: 'BANCO AMERICA DO SUL S.A' },
  { value: '216', name: 'BANCO REGIONAL MALCON S.A' },
  { value: '217', name: 'BANCO AGROINVEST S.A' },
  { value: '218', name: 'BS2' },
  { value: '219', name: 'BANCO DE CREDITO DE SAO PAULO S.A' },
  { value: '220', name: 'BANCO CREFISUL' },
  { value: '221', name: 'BANCO GRAPHUS S.A' },
  { value: '222', name: 'BANCO AGF BRASIL S. A.' },
  { value: '223', name: 'BANCO INTERUNION S.A' },
  { value: '224', name: 'BANCO FIBRA S.A' },
  { value: '225', name: 'BANCO BRASCAN S.A' },
  { value: '228', name: 'BANCO ICATU S.A' },
  { value: '229', name: 'BANCO CRUZEIRO S.A' },
  { value: '230', name: 'BANCO BANDEIRANTES S.A' },
  { value: '231', name: 'BANCO BOAVISTA S.A' },
  { value: '232', name: 'BANCO INTERPART S.A' },
  { value: '233', name: 'BANCO MAPPIN S.A' },
  { value: '234', name: 'BANCO LAVRA S.A.' },
  { value: '235', name: 'BANCO LIBERAL S.A' },
  { value: '236', name: 'BANCO CAMBIAL S.A' },
  { value: '239', name: 'BANCO BANCRED S.A' },
  { value: '240', name: 'BANCO DE CREDITO REAL DE MINAS GERAIS S.' },
  { value: '241', name: 'BANCO CLASSICO S.A' },
  { value: '242', name: 'BANCO EUROINVEST S.A' },
  { value: '243', name: 'BANCO MÁXIMA S.A' },
  { value: '244', name: 'BANCO CIDADE S.A' },
  { value: '245', name: 'BANCO EMPRESARIAL S.A' },
  { value: '246', name: 'BANCO ABC ROMA S.A' },
  { value: '247', name: 'BANCO OMEGA S.A' },
  { value: '249', name: 'BANCO INVESTCRED S.A' },
  { value: '250', name: 'BANCO SCHAHIN CURY S.A' },
  { value: '251', name: 'BANCO SAO JORGE S.A.' },
  { value: '252', name: 'BANCO FININVEST S.A' },
  { value: '254', name: 'BANCO PARANA BANCO S.A' },
  { value: '255', name: 'MILBANCO S.A.' },
  { value: '256', name: 'BANCO GULVINVEST S.A' },
  { value: '258', name: 'BANCO INDUSCRED S.A' },
  { value: '261', name: 'BANCO VARIG S.A' },
  { value: '262', name: 'BANCO BOREAL S.A' },
  { value: '263', name: 'BANCO CACIQUE' },
  { value: '264', name: 'BANCO PERFORMANCE S.A' },
  { value: '265', name: 'BANCO FATOR S.A' },
  { value: '266', name: 'BANCO CEDULA S.A' },
  { value: '267', name: 'BANCO BBM-COM.C.IMOB.CFI S.A.' },
  { value: '275', name: 'BANCO REAL S.A' },
  { value: '277', name: 'BANCO PLANIBANC S.A' },
  { value: '282', name: 'BANCO BRASILEIRO COMERCIAL' },
  { value: '291', name: 'BANCO DE CREDITO NACIONAL S.A' },
  { value: '294', name: 'BCR - BANCO DE CREDITO REAL S.A' },
  { value: '295', name: 'BANCO CREDIPLAN S.A' },
  { value: '300', name: 'BANCO DE LA NACION ARGENTINA S.A' },
  { value: '302', name: 'BANCO DO PROGRESSO S.A' },
  { value: '303', name: 'BANCO HNF S.A.' },
  { value: '304', name: 'BANCO PONTUAL S.A' },
  { value: '308', name: 'BANCO COMERCIAL BANCESA S.A.' },
  { value: '318', name: 'BANCO B.M.G. S.A' },
  { value: '320', name: 'BANCO INDUSTRIAL E COMERCIAL' },
  { value: '346', name: 'BANCO FRANCES E BRASILEIRO S.A' },
  { value: '347', name: 'BANCO SUDAMERIS BRASIL S.A' },
  { value: '351', name: 'BANCO BOZANO SIMONSEN S.A' },
  { value: '353', name: 'BANCO GERAL DO COMERCIO S.A' },
  { value: '356', name: 'ABN AMRO S.A' },
  { value: '366', name: 'BANCO SOGERAL S.A' },
  { value: '369', name: 'PONTUAL' },
  { value: '370', name: 'BEAL - BANCO EUROPEU PARA AMERICA LATINA' },
  { value: '372', name: 'BANCO ITAMARATI S.A' },
  { value: '375', name: 'BANCO FENICIA S.A' },
  { value: '376', name: 'CHASE MANHATTAN BANK S.A' },
  { value: '388', name: 'BANCO MERCANTIL DE DESCONTOS S/A' },
  { value: '389', name: 'BANCO MERCANTIL DO BRASIL S.A' },
  { value: '392', name: 'BANCO MERCANTIL DE SAO PAULO S.A' },
  { value: '394', name: 'BANCO B.M.C. S.A' },
  { value: '409', name: 'UNIBANCO - UNIAO DOS BANCOS BRASILEIROS' },
  { value: '412', name: 'BANCO NACIONAL DA BAHIA S.A' },
  { value: '415', name: 'BANCO NACIONAL S.A' },
  { value: '420', name: 'BANCO NACIONAL DO NORTE S.A' },
  { value: '424', name: 'BANCO NOROESTE S.A' },
  { value: '434', name: 'BANCO FORTALEZA S.A' },
  { value: '453', name: 'BANCO RURAL S.A' },
  { value: '456', name: 'BANCO TOKIO S.A' },
  { value: '464', name: 'BANCO SUMITOMO BRASILEIRO S.A' },
  { value: '466', name: 'BANCO MITSUBISHI BRASILEIRO S.A' },
  { value: '472', name: 'LLOYDS BANK PLC' },
  { value: '473', name: 'BANCO FINANCIAL PORTUGUES S.A' },
  { value: '477', name: 'CITIBANK N.A' },
  { value: '479', name: 'BANCO DE BOSTON S.A' },
  { value: '480', name: 'BANCO PORTUGUES DO ATLANTICO-BRASIL S.A' },
  { value: '483', name: 'BANCO AGRIMISA S.A.' },
  { value: '487', name: 'DEUTSCHE BANK S.A - BANCO ALEMAO' },
  { value: '488', name: 'BANCO J. P. MORGAN S.A' },
  { value: '489', name: 'BANESTO BANCO URUGAUAY S.A' },
  { value: '492', name: 'INTERNATIONALE NEDERLANDEN BANK N.V.' },
  { value: '493', name: 'BANCO UNION S.A.C.A' },
  { value: '494', name: 'BANCO LA REP. ORIENTAL DEL URUGUAY' },
  { value: '495', name: 'BANCO LA PROVINCIA DE BUENOS AIRES' },
  { value: '496', name: 'BANCO EXTERIOR DE ESPANA S.A' },
  { value: '498', name: 'CENTRO HISPANO BANCO' },
  { value: '499', name: 'BANCO IOCHPE S.A' },
  { value: '501', name: 'BANCO BRASILEIRO IRAQUIANO S.A.' },
  { value: '502', name: 'BANCO SANTANDER DE NEGOCIOS S.A' },
  { value: '504', name: 'BANCO MULTIPLIC S.A' },
  { value: '505', name: 'BANCO GARANTIA S.A' },
  { value: '600', name: 'BANCO LUSO BRASILEIRO S.A' },
  { value: '601', name: 'BFC BANCO S.A.' },
  { value: '602', name: 'BANCO PATENTE S.A' },
  { value: '604', name: 'BANCO INDUSTRIAL DO BRASIL S.A' },
  { value: '607', name: 'BANCO SANTOS NEVES S.A' },
  { value: '608', name: 'BANCO OPEN S.A' },
  { value: '610', name: 'BANCO V.R. S.A' },
  { value: '611', name: 'BANCO PAULISTA S.A' },
  { value: '612', name: 'BANCO GUANABARA S.A' },
  { value: '613', name: 'BANCO PECUNIA S.A' },
  { value: '616', name: 'BANCO INTERPACIFICO S.A' },
  { value: '617', name: 'BANCO INVESTOR S.A.' },
  { value: '618', name: 'BANCO TENDENCIA S.A' },
  { value: '621', name: 'BANCO APLICAP S.A.' },
  { value: '622', name: 'BANCO DRACMA S.A' },
  { value: '623', name: 'BANCO PANAMERICANO S.A' },
  { value: '624', name: 'BANCO GENERAL MOTORS S.A' },
  { value: '625', name: 'BANCO ARAUCARIA S.A' },
  { value: '626', name: 'BANCO FICSA S.A' },
  { value: '627', name: 'BANCO DESTAK S.A' },
  { value: '628', name: 'BANCO CRITERIUM S.A' },
  { value: '629', name: 'BANCORP BANCO COML. E. DE INVESTMENTO' },
  { value: '630', name: 'BANCO INTERCAP S.A' },
  { value: '633', name: 'BANCO REDIMENTO S.A' },
  { value: '634', name: 'BANCO TRIANGULO S.A' },
  { value: '635', name: 'BANCO DO ESTADO DO AMAPA S.A' },
  { value: '637', name: 'BANCO SOFISA S.A' },
  { value: '638', name: 'BANCO PROSPER S.A' },
  { value: '639', name: 'BIG S.A. - BANCO IRMAOS GUIMARAES' },
  { value: '640', name: 'BANCO DE CREDITO METROPOLITANO S.A' },
  { value: '641', name: 'BANCO EXCEL ECONOMICO S/A' },
  { value: '643', name: 'BANCO SEGMENTO S.A' },
  { value: '645', name: 'BANCO DO ESTADO DE RORAIMA S.A' },
  { value: '647', name: 'BANCO MARKA S.A' },
  { value: '648', name: 'BANCO ATLANTIS S.A' },
  { value: '649', name: 'BANCO DIMENSAO S.A' },
  { value: '650', name: 'BANCO PEBB S.A' },
  { value: '652', name: 'BANCO FRANCES E BRASILEIRO SA' },
  { value: '653', name: 'BANCO INDUSVAL S.A' },
  { value: '654', name: 'BANCO A. J. RENNER S.A' },
  { value: '655', name: 'BANCO VOTORANTIM S.A.' },
  { value: '656', name: 'BANCO MATRIX S.A' },
  { value: '657', name: 'BANCO TECNICORP S.A' },
  { value: '658', name: 'BANCO PORTO REAL S.A' },
  { value: '702', name: 'BANCO SANTOS S.A' },
  { value: '705', name: 'BANCO INVESTCORP S.A.' },
  { value: '707', name: 'BANCO DAYCOVAL S.A' },
  { value: '711', name: 'BANCO VETOR S.A.' },
  { value: '713', name: 'BANCO CINDAM S.A' },
  { value: '715', name: 'BANCO VEGA S.A' },
  { value: '718', name: 'BANCO OPERADOR S.A' },
  { value: '719', name: 'BANCO PRIMUS S.A' },
  { value: '720', name: 'BANCO MAXINVEST S.A' },
  { value: '721', name: 'BANCO CREDIBEL S.A' },
  { value: '722', name: 'BANCO INTERIOR DE SAO PAULO S.A' },
  { value: '724', name: 'BANCO PORTO SEGURO S.A' },
  { value: '725', name: 'BANCO FINABANCO S.A' },
  { value: '726', name: 'BANCO UNIVERSAL S.A' },
  { value: '728', name: 'BANCO FITAL S.A' },
  { value: '729', name: 'BANCO FONTE S.A' },
  { value: '730', name: 'BANCO COMERCIAL PARAGUAYO S.A' },
  { value: '731', name: 'BANCO GNPP S.A.' },
  { value: '732', name: 'BANCO PREMIER S.A.' },
  { value: '733', name: 'BANCO NACOES S.A.' },
  { value: '734', name: 'BANCO GERDAU S.A' },
  { value: '735', name: 'BANCO NEON' },
  { value: '736', name: 'BANCO UNITED S.A' },
  { value: '737', name: 'THECA' },
  { value: '738', name: 'MARADA' },
  { value: '739', name: 'BGN' },
  { value: '740', name: 'BCN BARCLAYS' },
  { value: '741', name: 'BRP' },
  { value: '742', name: 'EQUATORIAL' },
  { value: '743', name: 'BANCO EMBLEMA S.A' },
  { value: '744', name: 'THE FIRST NATIONAL BANK OF BOSTON' },
  { value: '746', name: 'MODAL S.A.' },
  { value: '747', name: 'RABOBANK DO BRASIL' },
  { value: '748', name: 'SICREDI' },
  { value: '749', name: 'BRMSANTIL SA' },
  { value: '750', name: 'BANCO REPUBLIC NATIONAL OF NEW YORK (BRA' },
  { value: '751', name: 'DRESDNER BANK LATEINAMERIKA-BRASIL S/A' },
  { value: '752', name: 'BANCO BANQUE NATIONALE DE PARIS BRASIL S' },
  { value: '753', name: 'BANCO COMERCIAL URUGUAI S.A.' },
  { value: '755', name: 'BANCO MERRILL LYNCH S.A' },
  { value: '757', name: 'BANCO KEB DO BRASIL S.A.' },
  { value: '260', name: 'Nu Pagamentos S.A' },
  { value: '102', name: 'XP INVESTIMENTOS' },
  { value: '336', name: 'BANCO C6 S.A.' },
  { value: '290', name: 'PagSeguro Internet S.A.' },
  { value: '323', name: 'MercadoPago.com Representações Ltda.' },
  { value: '332', name: 'Acesso Soluções de Pagamento S.A.' },
  { value: '325', name: 'Órama DTVM S.A.' },
  { value: '085', name: 'COOPERATIVA CENTRAL DE CREDITO - AILOS' },
  { value: '125', name: 'PLURAL S.A. BANCO MULTIPLO' },
  { value: '197', name: 'STONE PAGAMENTOS S.A.' },
  { value: '380', name: 'PICPAY SERVIÇOS S.A.' },
  { value: '335', name: 'BANCO DIGIO S.A.' },
];

export enum BankType {
  conta_corrente = 'checking',
  conta_poupanca = 'savings',
}

export function getBankTypeLabel(type: BankType): string {
  return (
    {
      [BankType.conta_corrente]: i18n.t('common:bankType.currentAccount'),
      [BankType.conta_poupanca]: i18n.t('common:bankType.savingsAccount'),
    }[type] ?? type
  );
}

export enum License {
  editorial = 'editorial',
  commercial = 'commercial',
}

export function getLicenseLabel(license: License): string {
  return (
    {
      [License.editorial]: i18n.t('common:license.editorial'),
      [License.commercial]: i18n.t('common:license.commercial'),
    }[license] ?? license
  );
}

export const MainCategorySlug = 'principais';

export enum ReleaseType {
  actor = 'actor',
  property = 'property',
}

export enum ApprovalState {
  pending = 'pending',
  approved = 'approved',
  refused = 'refused',
  processing = 'processing',
}

export function getApprovalStateLabel(state: ApprovalState): string {
  return (
    {
      [ApprovalState.pending]: i18n.t('common:approval.waiting'),
      [ApprovalState.approved]: i18n.t('common:approval.approved'),
      [ApprovalState.refused]: i18n.t('common:approval.refused'),
      [ApprovalState.processing]: i18n.t('common:approval.processingMedia'),
    }[state] ?? state
  );
}

export const ApprovalStatusColor = {
  [ApprovalState.pending]: '#ff9a00',
  [ApprovalState.approved]: '#19BABB',
  [ApprovalState.processing]: '#19BABB',
  [ApprovalState.refused]: '#FF6868',
};

export enum StatusState {
  open = 'open',
  done = 'done',
  canceled = 'canceled',
  paused = 'paused',
  failed = 'failed',
}

export function getStatusStateLabel(state: StatusState): string {
  return (
    {
      [StatusState.open]: i18n.t('common:statusState.open'),
      [StatusState.done]: i18n.t('common:statusState.completed'),
      [StatusState.canceled]: i18n.t('common:statusState.canceled'),
      [StatusState.paused]: i18n.t('common:statusState.paused'),
      [StatusState.failed]: i18n.t('common:statusState.failed'),
    }[state] ?? state
  );
}

export enum ResourceType {
  all = 'all',
  program = 'program',
  project = 'project',
  actionplan = 'actionplan',
  action = 'action',
}

export enum ResourceReviewType {
  customKPIValue = 'custom_kpi_value',
  actionStatus = 'action_status',
  actionPlanStatus = 'action_plan_status',
  projectStatus = 'project_status',
}

export function getResourceTypeLabel(type: ResourceType): string {
  return (
    {
      [ResourceType.all]: i18n.t('planning:filter.resourceTypes.all'),
      [ResourceType.program]: i18n.t('planning:filter.resourceTypes.program'),
      [ResourceType.project]: i18n.t('planning:filter.resourceTypes.project'),
      [ResourceType.actionplan]: i18n.t(
        'planning:filter.resourceTypes.actionPlan'
      ),
      [ResourceType.action]: i18n.t('planning:filter.resourceTypes.action'),
    }[type] ?? type
  );
}

export enum DeadlineStatus {
  all = 'all',
  overdue = 'overdue',
  nearDeadline = 'nearDeadline',
}

export function getDeadlineStatusLabel(status: DeadlineStatus): string {
  return (
    {
      [DeadlineStatus.all]: i18n.t('planning:filter.deadlineStatuses.all'),
      [DeadlineStatus.overdue]: i18n.t(
        'planning:filter.deadlineStatuses.overdue'
      ),
      [DeadlineStatus.nearDeadline]: i18n.t(
        'planning:filter.deadlineStatuses.nearDeadline'
      ),
    }[status] ?? status
  );
}

export const DefaultTemplateID = 'default';

export enum SaleStatus {
  open = 'open',
  done = 'done',
  paid = 'paid',
  waiting = 'waiting_payment',
  refused = 'refused',
  canceled = 'canceled',
  failed = 'failed',
}

export function getSaleStatusLabel(status: SaleStatus): string {
  return (
    {
      [SaleStatus.open]: i18n.t('common:saleStatus.open'),
      [SaleStatus.done]: i18n.t('common:saleStatus.completed'),
      [SaleStatus.canceled]: i18n.t('common:saleStatus.canceled'),
      [SaleStatus.paid]: i18n.t('common:saleStatus.paid'),
      [SaleStatus.waiting]: i18n.t('common:saleStatus.waiting'),
      [SaleStatus.refused]: i18n.t('common:saleStatus.refused'),
      [SaleStatus.failed]: i18n.t('common:saleStatus.failed'),
    }[status] ?? status
  );
}

export enum PaymentStatus {
  paid = 'paid',
  rejected = 'rejected',
  refunded = 'refunded',
  refused = 'refused',
  pending = 'pending',
  waiting = 'waiting_payment',
  authorized = 'authorized',
  canceled = 'canceled',
  processing = 'processing',
  failed = 'failed',
}

export function getPaymentStatusLabel(s?: string | null, alt?: string) {
  if (s === undefined || s === null) {
    return alt;
  }
  return (
    (
      {
        [PaymentStatus.paid]: i18n.t('common:paymentStatus.paid'),
        [PaymentStatus.rejected]: i18n.t('common:paymentStatus.rejected'),
        [PaymentStatus.refused]: i18n.t('common:paymentStatus.refused'),
        [PaymentStatus.refunded]: i18n.t('common:paymentStatus.refunded'),
        [PaymentStatus.pending]: i18n.t('common:paymentStatus.pending'),
        [PaymentStatus.authorized]: i18n.t('common:paymentStatus.authorized'),
        [PaymentStatus.canceled]: i18n.t('common:paymentStatus.canceled'),
        [PaymentStatus.waiting]: i18n.t('common:paymentStatus.waiting'),
        [PaymentStatus.processing]: i18n.t('common:paymentStatus.processing'),
        [PaymentStatus.failed]: i18n.t('common:paymentStatus.failed'),
      } as any
    )[s] ?? i18n.t('common:paymentStatus.error')
  );
}

export enum MetricKPIOptions {
  surveysQuantity = 'surveysQuantity',
  actionsQuantity = 'actionsQuantity',
  projectsQuantity = 'projectsQuantity',
  programasQuantity = 'programasQuantity',
  subMetrics = 'subMetrics',
  custom = 'custom',
}

export function getMetricKPIOptionsLabel(s?: string | null, alt?: string) {
  if (s === undefined || s === null) {
    return alt;
  }
  return (
    (
      {
        [MetricKPIOptions.surveysQuantity]: i18n.t(
          'common:metrics.surveysQuantity'
        ),
        [MetricKPIOptions.actionsQuantity]: i18n.t(
          'common:metrics.actionsQuantity'
        ),
        [MetricKPIOptions.projectsQuantity]: i18n.t(
          'common:metrics.projectsQuantity'
        ),
        [MetricKPIOptions.programasQuantity]: i18n.t(
          'common:metrics.programsQuantity'
        ),
        [MetricKPIOptions.custom]: i18n.t('common:metrics.custom'),
      } as any
    )[s] ?? i18n.t('common:errors.transactionError')
  );
}

export enum MetricCalculationOptions {
  sum = 'sum',
  latestValue = 'latestValue',
  oldestValue = 'oldestValue',
  weightedAverage = 'weightedAverage',
}

export function getMetricCalculationOptionsLabel(
  s?: string | null,
  alt?: string
) {
  if (s === undefined || s === null) {
    return alt;
  }
  return (
    (
      {
        [MetricCalculationOptions.sum]: i18n.t('common:calculations.sum'),
        [MetricCalculationOptions.latestValue]: i18n.t(
          'common:calculations.latestValue'
        ),
        [MetricCalculationOptions.oldestValue]: i18n.t(
          'common:calculations.oldestValue'
        ),
        [MetricCalculationOptions.weightedAverage]: i18n.t(
          'common:calculations.weightedAverage'
        ),
      } as any
    )[s] ?? '--'
  );
}

export enum MetricOperationOptions {
  greaterThan = 'greaterThan',
  lessThan = 'lessThan',
  equalTo = 'equalTo',
  greaterOrEqualTo = 'greaterOrEqualTo',
  lessThanOrEqualTo = 'lessThanOrEqualTo',
}

export function getMetricOperationOptionsLabel(
  s?: string | null,
  alt?: string
) {
  if (s === undefined || s === null) {
    return alt;
  }
  return (
    (
      {
        [MetricOperationOptions.greaterThan]: i18n.t(
          'common:operations.greaterThan'
        ),
        [MetricOperationOptions.lessThan]: i18n.t('common:operations.lessThan'),
        [MetricOperationOptions.equalTo]: i18n.t('common:operations.equalTo'),
        [MetricOperationOptions.greaterOrEqualTo]: i18n.t(
          'common:operations.greaterOrEqualTo'
        ),
        [MetricOperationOptions.lessThanOrEqualTo]: i18n.t(
          'common:operations.lessThanOrEqualTo'
        ),
      } as any
    )[s] ?? i18n.t('common:errors.transactionError')
  );
}

export enum MetricTypeOptions {
  institutional = 'institutional',
  strategic = 'strategic',
  progress = 'progress',
  financial = 'financial',
  physical = 'physical',
}

export function getMetricTypeOptionsLabel(s?: string | null, alt?: string) {
  if (s === undefined || s === null) {
    return alt;
  }
  return (
    {
      [MetricTypeOptions.institutional]: i18n.t('common:metrics.institutional'),
      [MetricTypeOptions.strategic]: i18n.t('common:metrics.strategic'),
      [MetricTypeOptions.progress]: i18n.t('common:metrics.progress'),
      [MetricTypeOptions.financial]: i18n.t('common:metrics.financial'),
      [MetricTypeOptions.physical]: i18n.t('common:metrics.physical'),
    }[s] ?? i18n.t('common:errors.transactionError')
  );
}

export enum KPITypeOptions {
  performance = 'performance',
  progress = 'progress',
}

export function getKPITypeOptionsLabel(s?: string | null, alt?: string) {
  if (s === undefined || s === null) {
    return alt;
  }
  return (
    {
      [KPITypeOptions.performance]: i18n.t('common:labels.performance'),
      [KPITypeOptions.progress]: i18n.t('common:labels.progress'),
    }[s] ?? i18n.t('common:errors.transactionError')
  );
}

export enum UnitOfMeasureOptions {
  pkg = 'pkg',
  unit = 'unit',
  kg = 'kg',
  mg = 'mg',
  m = 'm',
  cm = 'cm',
  l = 'l',
  ml = 'ml',
}

export function getUnitOfMeasureOptionsLabel(s?: string | null, alt?: string) {
  if (s === undefined || s === null) {
    return alt;
  }
  return (
    (
      {
        [UnitOfMeasureOptions.pkg]: i18n.t('common:units.package'),
        [UnitOfMeasureOptions.unit]: i18n.t('common:units.unit'),
        [UnitOfMeasureOptions.kg]: 'kg',
        [UnitOfMeasureOptions.mg]: 'mg',
        [UnitOfMeasureOptions.m]: 'm',
        [UnitOfMeasureOptions.cm]: 'cm',
        [UnitOfMeasureOptions.l]: 'l',
        [UnitOfMeasureOptions.ml]: 'ml',
      } as any
    )[s] ?? i18n.t('common:errors.transactionError')
  );
}

export enum InvolvementTypeOptions {
  victim = 'victim',
  agressor = 'agressor',
  witness = 'witness',
}

export function getInvolvementTypeOptionsLabel(
  s?: string | null,
  alt?: string
) {
  if (s === undefined || s === null) {
    return alt;
  }
  return (
    (
      {
        [InvolvementTypeOptions.victim]: i18n.t('common:involvement.victim'),
        [InvolvementTypeOptions.agressor]: i18n.t(
          'common:involvement.aggressor'
        ),
        [InvolvementTypeOptions.witness]: i18n.t('common:involvement.witness'),
      } as any
    )[s] ?? i18n.t('common:errors.transactionError')
  );
}

export enum SkinToneOptions {
  black = 'black',
  brown = 'brown',
  yellow = 'yellow',
  indigenous = 'indigenous',
  white = 'white',
  noAnswer = 'noAnswer',
}

export function getSkinToneOptionsLabel(s?: string | null, alt?: string) {
  if (s === undefined || s === null) {
    return alt;
  }
  return (
    (
      {
        [SkinToneOptions.black]: i18n.t('common:skinTone.black'),
        [SkinToneOptions.brown]: i18n.t('common:skinTone.brown'),
        [SkinToneOptions.yellow]: i18n.t('common:skinTone.yellow'),
        [SkinToneOptions.indigenous]: i18n.t('common:skinTone.indigenous'),
        [SkinToneOptions.white]: i18n.t('common:skinTone.white'),
        [SkinToneOptions.noAnswer]: i18n.t('common:skinTone.noAnswer'),
      } as any
    )[s] ?? i18n.t('common:errors.transactionError')
  );
}

export enum MaritalStatusOptions {
  single = 'single',
  married = 'married',
  divorced = 'divorced',
  widowed = 'widowed',
  stableUnion = 'stableUnion',
  separated = 'separated',
  dating = 'dating',
}

export function getMaritalStatusOptionsLabel(s?: string | null, alt?: string) {
  if (s === undefined || s === null) {
    return alt;
  }
  return (
    (
      {
        [MaritalStatusOptions.single]: i18n.t('common:maritalStatus.single'),
        [MaritalStatusOptions.married]: i18n.t('common:maritalStatus.married'),
        [MaritalStatusOptions.divorced]: i18n.t(
          'common:maritalStatus.divorced'
        ),
        [MaritalStatusOptions.widowed]: i18n.t('common:maritalStatus.widowed'),
        [MaritalStatusOptions.stableUnion]: i18n.t(
          'common:maritalStatus.stableUnion'
        ),
        [MaritalStatusOptions.separated]: i18n.t(
          'common:maritalStatus.separated'
        ),
        [MaritalStatusOptions.dating]: i18n.t('common:maritalStatus.dating'),
      } as any
    )[s] ?? i18n.t('common:errors.transactionError')
  );
}

export enum ReligionOptions {
  noReligion = 'noReligion',
  atheist = 'atheist',
  catholic = 'catholic',
  spiritist = 'spiritist',
  evangelical = 'evangelical',
  jehovahsWitness = 'jehovahsWitness',
  africanMatrix = 'africanMatrix',
  mormon = 'mormon',
  buddhism = 'buddhism',
  others = 'others',
}

export function getReligionOptionsLabel(s?: string | null, alt?: string) {
  if (s === undefined || s === null) {
    return alt;
  }
  return (
    (
      {
        [ReligionOptions.noReligion]: i18n.t('common:religion.noReligion'),
        [ReligionOptions.atheist]: i18n.t('common:religion.atheist'),
        [ReligionOptions.catholic]: i18n.t('common:religion.catholic'),
        [ReligionOptions.spiritist]: i18n.t('common:religion.spiritist'),
        [ReligionOptions.evangelical]: i18n.t('common:religion.evangelical'),
        [ReligionOptions.jehovahsWitness]: i18n.t(
          'common:religion.jehovahsWitness'
        ),
        [ReligionOptions.africanMatrix]: i18n.t(
          'common:religion.africanMatrix'
        ),
        [ReligionOptions.mormon]: i18n.t('common:religion.mormon'),
        [ReligionOptions.buddhism]: i18n.t('common:religion.buddhism'),
        [ReligionOptions.others]: i18n.t('common:religion.others'),
      } as any
    )[s] ?? i18n.t('common:errors.transactionError')
  );
}

export enum EducationLevelOptions {
  illiterate = 'illiterate',
  elementaryIIncomplete = 'elementaryIIncomplete',
  elementaryIComplete = 'elementaryIComplete',
  elementaryIIIncomplete = 'elementaryIIIncomplete',
  elementaryIIComplete = 'elementaryIIComplete',
  highSchoolIncomplete = 'highSchoolIncomplete',
  highSchoolComplete = 'highSchoolComplete',
  higherEducationIncomplete = 'higherEducationIncomplete',
  higherEducationComplete = 'higherEducationComplete',
  postGraduate = 'postGraduate',
  master = 'master',
  doctorate = 'doctorate',
}

export function getEducationLevelOptionsLabel(s?: string | null, alt?: string) {
  if (s === undefined || s === null) {
    return alt;
  }
  return (
    (
      {
        [EducationLevelOptions.illiterate]: i18n.t(
          'common:education.illiterate'
        ),
        [EducationLevelOptions.elementaryIIncomplete]: i18n.t(
          'common:education.elementaryIIncomplete'
        ),
        [EducationLevelOptions.elementaryIComplete]: i18n.t(
          'common:education.elementaryIComplete'
        ),
        [EducationLevelOptions.elementaryIIIncomplete]: i18n.t(
          'common:education.elementaryIIIncomplete'
        ),
        [EducationLevelOptions.elementaryIIComplete]: i18n.t(
          'common:education.elementaryIIComplete'
        ),
        [EducationLevelOptions.highSchoolIncomplete]: i18n.t(
          'common:education.highSchoolIncomplete'
        ),
        [EducationLevelOptions.highSchoolComplete]: i18n.t(
          'common:education.highSchoolComplete'
        ),
        [EducationLevelOptions.higherEducationIncomplete]: i18n.t(
          'common:education.higherEducationIncomplete'
        ),
        [EducationLevelOptions.higherEducationComplete]: i18n.t(
          'common:education.higherEducationComplete'
        ),
        [EducationLevelOptions.postGraduate]: i18n.t(
          'common:education.postGraduate'
        ),
        [EducationLevelOptions.master]: i18n.t('common:education.master'),
        [EducationLevelOptions.doctorate]: i18n.t('common:education.doctorate'),
      } as any
    )[s] ?? i18n.t('common:errors.transactionError')
  );
}

export enum IncomeOptions {
  upToOneMinimumWage = 'upToOneMinimumWage',
  moreThanOneToTwoMinimumWages = 'moreThanOneToTwoMinimumWages',
  moreThanTwoToThreeMinimumWages = 'moreThanTwoToThreeMinimumWages',
  moreThanThreeToFourMinimumWages = 'moreThanThreeToFourMinimumWages',
  aboveFourMinimumWages = 'aboveFourMinimumWages',
  noIncome = 'noIncome',
}

export function getIncomeOptionsLabel(s?: string | null, alt?: string) {
  if (s === undefined || s === null) {
    return alt;
  }
  return (
    (
      {
        [IncomeOptions.upToOneMinimumWage]: i18n.t(
          'common:income.upToOneMinimumWage'
        ),
        [IncomeOptions.moreThanOneToTwoMinimumWages]: i18n.t(
          'common:income.moreThanOneToTwoMinimumWages'
        ),
        [IncomeOptions.moreThanTwoToThreeMinimumWages]: i18n.t(
          'common:income.moreThanTwoToThreeMinimumWages'
        ),
        [IncomeOptions.moreThanThreeToFourMinimumWages]: i18n.t(
          'common:income.moreThanThreeToFourMinimumWages'
        ),
        [IncomeOptions.aboveFourMinimumWages]: i18n.t(
          'common:income.aboveFourMinimumWages'
        ),
        [IncomeOptions.noIncome]: i18n.t('common:income.noIncome'),
      } as any
    )[s] ?? i18n.t('common:errors.transactionError')
  );
}

export enum ProfessionalActivityOptions {
  selfEmployed = 'selfEmployed',
  retired = 'retired',
  unemployed = 'unemployed',
  entrepreneur = 'entrepreneur',
  formalWork = 'formalWork',
  informalWork = 'informalWork',
  publicServant = 'publicServant',
  onLeave = 'onLeave',
}

export function getProfessionalActivityOptionsLabel(
  s?: string | null,
  alt?: string
) {
  if (s === undefined || s === null) {
    return alt;
  }
  return (
    (
      {
        [ProfessionalActivityOptions.selfEmployed]: i18n.t(
          'common:profession.selfEmployed'
        ),
        [ProfessionalActivityOptions.retired]: i18n.t(
          'common:profession.retired'
        ),
        [ProfessionalActivityOptions.unemployed]: i18n.t(
          'common:profession.unemployed'
        ),
        [ProfessionalActivityOptions.entrepreneur]: i18n.t(
          'common:profession.entrepreneur'
        ),
        [ProfessionalActivityOptions.formalWork]: i18n.t(
          'common:profession.formalWork'
        ),
        [ProfessionalActivityOptions.informalWork]: i18n.t(
          'common:profession.informalWork'
        ),
        [ProfessionalActivityOptions.publicServant]: i18n.t(
          'common:profession.publicServant'
        ),
        [ProfessionalActivityOptions.onLeave]: i18n.t(
          'common:profession.onLeave'
        ),
      } as any
    )[s] ?? i18n.t('common:errors.transactionError')
  );
}

export enum MetricDisplayModeOptions {
  percentage = 'percentage',
  integer = 'integer',
}

export function getMetricDisplayModeOptionsLabel(
  s?: string | null,
  alt?: string
) {
  if (s === undefined || s === null) {
    return alt;
  }
  return (
    (
      {
        [MetricDisplayModeOptions.percentage]: i18n.t(
          'common:displayMode.percentage'
        ),
        [MetricDisplayModeOptions.integer]: i18n.t(
          'common:displayMode.integer'
        ),
      } as any
    )[s] ?? i18n.t('common:errors.transactionError')
  );
}

export enum MetricStatusOptions {
  active = 'active',
  inactive = 'inactive',
}

export function getMetricStatusOptionsLabel(s?: string | null, alt?: string) {
  if (s === undefined || s === null) {
    return alt;
  }
  return (
    (
      {
        [MetricStatusOptions.active]: i18n.t('common:status.active'),
        [MetricStatusOptions.inactive]: i18n.t('common:status.inactive'),
      } as any
    )[s] ?? ''
  );
}

export enum SupportedPaymentMethod {
  boleto = 'pagarme.boleto',
  creditcard = 'pagarme.card',
  pix = 'pagarme.pix',

  voucher = 'voucher',
}

export function getSupportedPaymentMethodLabel(
  method: SupportedPaymentMethod
): string {
  return (
    {
      [SupportedPaymentMethod.boleto]: i18n.t('common:paymentMethod.bankSlip'),
      [SupportedPaymentMethod.creditcard]: i18n.t(
        'common:paymentMethod.creditCard'
      ),
      [SupportedPaymentMethod.pix]: 'PIX',
      [SupportedPaymentMethod.voucher]: i18n.t('common:paymentMethod.voucher'),
    }[method] ?? method
  );
}

export function getPaymentMethodLabel(s?: string | null, alt?: string) {
  if (s === undefined || s === null) {
    return alt;
  }
  return getSupportedPaymentMethodLabel(s as SupportedPaymentMethod) ?? alt;
}

export enum BankDocumentType {
  cpf = 'cpf',
  cnpj = 'cnpj',
}

export enum SaleActionType {
  open = 'open',
  cancel = 'cancel',
  conclude = 'conclude',
}

export enum AuthenticationProvider {
  cidade360 = 'cidade360',
  google = 'google',
}

export enum AccessModel {
  token = 'token',
  link = 'link',
}

export enum CartResourceTypes {
  voucher = 'voucher',
}

export enum InvoiceItemResourceTypes {
  voucher = 'voucher',
  product = 'product',
}

export enum ApplicationID {
  admin = 'admin',
}

export const VideoExtensions = ['mp4', 'mov', 'avi', 'wmv', 'flv', 'webm'];
export const VideoTypes = [
  'video/mp4',
  'video/quicktime',
  'video/x-msvideo',
  'video/x-ms-wmv',
  'video/x-flv',
  'video/webm',
];

export const ImageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp'];
export const ImageTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp'];

export const FixedPcopIDs = [1];

export const formatConfigurationIDs = [1, 2];

export enum UserPermissions {
  admin = 'admin',
  respondent = 'respondent',
  pollManager = 'pollManager',
  pollViewer = 'pollViewer',
  planManager = 'planManager',
  relator = 'relator',
  agent = 'agent',
  fieldAgent = 'fieldAgent',
  workOrderManager = 'workOrderManager',
  incidentManager = 'incidentManager',
  institutionAdmin = 'institutionAdmin',
}

export function getUserPermissionsLabel(s?: string | null, alt?: string) {
  if (s === undefined || s === null) {
    return alt;
  }
  return (
    (
      {
        [UserPermissions.admin]: i18n.t('common:userPermissions.admin'),
        [UserPermissions.respondent]: i18n.t(
          'common:userPermissions.respondent'
        ),
        [UserPermissions.pollManager]: i18n.t(
          'common:userPermissions.pollManager'
        ),
        [UserPermissions.pollViewer]: i18n.t(
          'common:userPermissions.pollViewer'
        ),
        [UserPermissions.planManager]: i18n.t(
          'common:userPermissions.planManager'
        ),
        [UserPermissions.relator]: i18n.t('common:userPermissions.relator'),
        [UserPermissions.agent]: i18n.t('common:userPermissions.agent'),
        [UserPermissions.fieldAgent]: i18n.t(
          'common:userPermissions.fieldAgent'
        ),
        [UserPermissions.workOrderManager]: i18n.t(
          'common:userPermissions.workOrderManager'
        ),
        [UserPermissions.incidentManager]: i18n.t(
          'common:userPermissions.incidentManager'
        ),
        [UserPermissions.institutionAdmin]: i18n.t(
          'common:userPermissions.institutionAdmin'
        ),
      } as any
    )[s] ?? alt
  );
}

export const DefaultPermissionDocument = '*';

export enum ActionPlanType {
  program = 'program',
  project = 'project',
  action = 'action',
  actionPlan = 'action-plan',
}

export function getActionPlanTypeLabel(s?: string | null, alt?: string) {
  if (s === undefined || s === null) {
    return alt;
  }
  return (
    (
      {
        [ActionPlanType.program]: i18n.t('common:entities.programs'),
        [ActionPlanType.project]: i18n.t('common:entities.projects'),
        [ActionPlanType.action]: i18n.t('common:entities.actions'),
        [ActionPlanType.actionPlan]: i18n.t('common:entities.actionPlans'),
      } as any
    )[s] ?? alt
  );
}

export const DefaultPlanID = 'ba035b85-319b-422e-b78b-94547989f93e';

export enum SexType {
  SexMale = 'm',
  SexFemale = 'f',
}

export function getSexTypeLabel(s?: string | null, alt?: string) {
  if (s === undefined || s === null) {
    return alt;
  }
  return (
    (
      {
        [SexType.SexMale]: i18n.t('common:sex.male'),
        [SexType.SexFemale]: i18n.t('common:sex.female'),
      } as any
    )[s] ?? alt
  );
}

export enum DepredationOwner {
  Private = 'private',
  Public = 'public',
}

export function getDepredationOwnerLabel(s?: string | null, alt?: string) {
  if (s === undefined || s === null) {
    return alt;
  }
  return (
    (
      {
        [DepredationOwner.Private]: i18n.t('common:ownership.private'),
        [DepredationOwner.Public]: i18n.t('common:ownership.public'),
      } as any
    )[s] ?? alt
  );
}

export enum DepredationLevel {
  Light = 'light',
  Medium = 'medium',
  High = 'high',
}

export function getDepredationLevelLabel(s?: string | null, alt?: string) {
  if (s === undefined || s === null) {
    return alt;
  }
  return (
    (
      {
        [DepredationLevel.Light]: i18n.t('common:depredation.light'),
        [DepredationLevel.Medium]: i18n.t('common:depredation.medium'),
        [DepredationLevel.High]: i18n.t('common:depredation.high'),
      } as any
    )[s] ?? alt
  );
}

export enum PlanDashBoardResourceType {
  project = 'project',
  actionPlan = 'action-plan',
  action = 'action',
}

export enum DocumentType {
  CPF = 'cpf',
  NIS = 'nis',
  RG = 'rg',
  BirthCertificate = 'birth_certificate',
  Passport = 'passport',
}

export function getDocumentTypeLabel(d?: string | null, alt?: string) {
  if (d === undefined || d === null) {
    return alt;
  }
  return (
    (
      {
        [DocumentType.CPF]: 'CPF',
        [DocumentType.NIS]: 'NIS',
        [DocumentType.RG]: 'RG',
        [DocumentType.BirthCertificate]: i18n.t(
          'common:documentType.birthCertificate'
        ),
        [DocumentType.Passport]: i18n.t('common:documentType.passport'),
      } as any
    )[d] ?? alt
  );
}

export function getPlanDashBoardResourceTypeLabel(
  s?: string | null,
  alt?: string
) {
  if (s === undefined || s === null) {
    return alt;
  }
  return (
    (
      {
        [PlanDashBoardResourceType.project]: i18n.t('common:entities.projects'),
        [PlanDashBoardResourceType.actionPlan]: i18n.t(
          'common:entities.actionPlans'
        ),
        [PlanDashBoardResourceType.action]: i18n.t(
          'common:entities.activities'
        ),
      } as any
    )[s] ?? alt
  );
}

export enum IncidentType {
  security = 'security',
  service = 'service',
}
export function getIncidentTypeLabel(s?: string | null, alt?: string) {
  if (s === undefined || s === null) {
    return alt;
  }
  return (
    (
      {
        [IncidentType.security]: i18n.t('common:incidentType.occurrence'),
        [IncidentType.service]: i18n.t('common:incidentType.service'),
      } as any
    )[s] ?? alt
  );
}

export enum OperationsForms {
  Incident = 'incident',
  WorkOrder = 'work_order',
}

export function getOperationsFormsLabel(s?: string | null, alt?: string) {
  if (s === undefined || s === null) {
    return alt;
  }
  return (
    (
      {
        [OperationsForms.Incident]: i18n.t('common:incidentType.service'),
        [OperationsForms.WorkOrder]: i18n.t('common:entities.workOrder'),
      } as any
    )[s] ?? alt
  );
}

export enum IncidentFormTextFields {
  SolutionDetails = 'details.solution',
  RelatorDescription = 'details.relatorDescription',
}

export function getIncidentFormTextFieldsLabel(
  s?: string | null,
  alt?: string
) {
  if (s === undefined || s === null) {
    return alt;
  }
  return (
    (
      {
        [IncidentFormTextFields.SolutionDetails]: 'Solução',
        [IncidentFormTextFields.RelatorDescription]: 'Narrativa',
      } as any
    )[s] ?? alt
  );
}

export enum WorkOrderFormTextFields {
  Description = 'description',
}

export function getWorkOrderFormTextFieldsLabel(
  s?: string | null,
  alt?: string
) {
  if (s === undefined || s === null) {
    return alt;
  }
  return (
    (
      {
        [WorkOrderFormTextFields.Description]: 'Descrição',
      } as any
    )[s] ?? alt
  );
}

export enum IncidentDefaultValues {
  DetailsSolution = 'details.solution',
  DetailsRelatorDescription = 'details.relatorDescription',
}

export enum WorkOrderDefaultValues {
  description = 'description',
}

export enum ManagementModules {
  planning = 'planning',
}

export enum TaskType {
  program = 'program',
  project = 'project',
  actionplan = 'actionplan',
  action = 'action',
}

export type TaskTypeKeys = keyof typeof TaskType;

export enum IncidentFieldKeys {
  inenID = 'inenID',
  agentID = 'agentID',
  addressNeighborhood = 'address.neighborhood',
  addressZipCode = 'address.zipCode',
  addressCity = 'address.city',
  addressComplement = 'address.complement',
  indiID = 'indiID',
  innaID = 'innaID',
  dinaID = 'dinaID',
  inbnID = 'inbnID',
  disuID = 'disuID',
  description = 'description',
  detailsRelatorDescription = 'details.relatorDescription',
  istaID = 'istaID',
  distID = 'distID',
  detailsProtocolNumber = 'details.protocolNumber',
  requesterName = 'requester.name',
  addressState = 'address.state',
  requesterEmail = 'requester.email',
  inorID = 'inorID',
  partnerInstID = 'partnerInstID',
  requesterSex = 'requester.sex',
  detailsSolution = 'details.solution',
  seizedItems = 'seizedItems',
  sechID = 'sechID',
  inprID = 'inprID',
  insuID = 'insuID',
  guicID = 'guicID',
  requesterPhone = 'requester.phone',
  iatyID = 'iatyID',
  addressStreet = 'address.street',
  addressLatitude = 'address.latitude',
  addressLongitude = 'address.longitude',
  workOrderUid = 'workOrderUid',
  relatorID = 'relatorID',
  inesID = 'inesID',
  pueqID = 'pueqID',
  involvedParties = 'involvedParties',
  diunID = 'diunID',
  addressNumber = 'address.number',
  incidentVehicles = 'incidentVehicles',
  servicedAt = 'servicedAt',
  arrivalAt = 'arrivalAt',
  addressIsVillage = 'address.isVillage',
}

export enum WorkOrderFieldKeys {
  attachment = 'attachment',
  addressNeighborhood = 'address.neighborhood',
  addressZipCode = 'address.zipCode',
  addressCity = 'address.city',
  woclID = 'woclID',
  addressComplement = 'address.complement',
  startAt = 'startAt',
  endAt = 'endAt',
  requesterDocumentNumber = 'requester.documentNumber',
  recoID = 'recoID',
  event = 'event',
  worfID = 'worfID',
  generalEffective = 'generalEffective',
  ordinaryEffective = 'ordinaryEffective',
  extraordinaryEffective = 'extraordinaryEffective',
  addressLatitude = 'address.latitude',
  addressLongitude = 'address.longitude',
  addressStreet = 'address.street',
  requesterName = 'requester.name',
  description = 'description',
  addressNumber = 'address.number',
  ureqID = 'ureqID',
  addressState = 'address.state',
  requesterPhone = 'requester.phone',
  wortID = 'wortID',
  woprID = 'woprID',
  wosuID = 'wosuID',
  wostID = 'wostID',
  fieldAgentUsers = 'fieldAgentUsers',
}

export const IncidentFields = {
  [IncidentFieldKeys.inenID]: 'Ambiente',
  [IncidentFieldKeys.agentID]: 'Atendente',
  [IncidentFieldKeys.addressNeighborhood]: 'Bairro',
  [IncidentFieldKeys.addressZipCode]: 'CEP',
  [IncidentFieldKeys.addressCity]: 'Cidade',
  [IncidentFieldKeys.addressComplement]: 'Complemento',
  [IncidentFieldKeys.indiID]: 'Despachante',
  [IncidentFieldKeys.innaID]: 'Natureza do atendimento',
  [IncidentFieldKeys.dinaID]: 'Natureza do despacho',
  [IncidentFieldKeys.inbnID]: 'Natureza subcategoria do atendimento',
  [IncidentFieldKeys.disuID]: 'Natureza subcategoria do despacho',
  [IncidentFieldKeys.description]: 'Narrativa',
  [IncidentFieldKeys.detailsRelatorDescription]: 'Narrativa do relator',
  [IncidentFieldKeys.istaID]: 'Status do atendimento',
  [IncidentFieldKeys.distID]: 'Status do despacho',
  [IncidentFieldKeys.detailsProtocolNumber]: 'Nº Protocolo F.A',
  [IncidentFieldKeys.requesterName]: 'Nome do solicitante',
  [IncidentFieldKeys.addressState]: 'Estado',
  [IncidentFieldKeys.requesterEmail]: 'Email do solicitante',
  [IncidentFieldKeys.inorID]: 'Origem do atendimento',
  [IncidentFieldKeys.partnerInstID]: 'Órgão parceiro',
  [IncidentFieldKeys.requesterSex]: 'Sexo do solicitante',
  [IncidentFieldKeys.detailsSolution]: 'Solução',
  [IncidentFieldKeys.seizedItems]: 'Materiais apreendidos',
  [IncidentFieldKeys.sechID]: 'Meio do atendimento',
  [IncidentFieldKeys.inprID]: 'Programa',
  [IncidentFieldKeys.insuID]: 'Subprograma',
  [IncidentFieldKeys.guicID]: 'Guichê',
  [IncidentFieldKeys.requesterPhone]: 'Telefone do solicitante',
  [IncidentFieldKeys.iatyID]: 'Tipo de atuação',
  [IncidentFieldKeys.addressStreet]: 'Logradouro',
  [IncidentFieldKeys.addressLatitude]: 'Latitude',
  [IncidentFieldKeys.addressLongitude]: 'Longitude',
  [IncidentFieldKeys.workOrderUid]: 'Número da O.S',
  [IncidentFieldKeys.relatorID]: 'Relator',
  [IncidentFieldKeys.inesID]: 'Estabelecimento',
  [IncidentFieldKeys.pueqID]: 'Equipamento público',
  [IncidentFieldKeys.involvedParties]: 'Partes envolvidas',
  [IncidentFieldKeys.diunID]: 'Unidade administrativa de despacho',
  [IncidentFieldKeys.addressNumber]: 'Número',
  [IncidentFieldKeys.incidentVehicles]: 'Veículos em uso',
  [IncidentFieldKeys.servicedAt]: 'Data e hora de início',
  [IncidentFieldKeys.addressIsVillage]: 'Vila ou invasão?',
};
export const WorkOrderFields = {
  [WorkOrderFieldKeys.attachment]: 'Anexo',
  [WorkOrderFieldKeys.addressNeighborhood]: 'Bairro',
  [WorkOrderFieldKeys.addressZipCode]: 'CEP',
  [WorkOrderFieldKeys.addressCity]: 'Cidade',
  [WorkOrderFieldKeys.woclID]: 'Classificação',
  [WorkOrderFieldKeys.addressComplement]: 'Complemento',
  [WorkOrderFieldKeys.startAt]: 'Data e hora de início',
  [WorkOrderFieldKeys.endAt]: 'Data e hora de fim',
  [WorkOrderFieldKeys.requesterDocumentNumber]: 'Documento do solicitante',
  [WorkOrderFieldKeys.recoID]: 'Empresa solicitante',
  [WorkOrderFieldKeys.event]: 'Evento',
  [WorkOrderFieldKeys.worfID]: 'Função do solicitante',
  [WorkOrderFieldKeys.generalEffective]: 'Nº Efetivo Geral',
  [WorkOrderFieldKeys.ordinaryEffective]: 'Nº Efetivo Ordinario',
  [WorkOrderFieldKeys.extraordinaryEffective]: 'Nº Efetivo Extraordinário',
  [WorkOrderFieldKeys.addressLatitude]: 'Latitude',
  [WorkOrderFieldKeys.addressLongitude]: 'Longitude',
  [WorkOrderFieldKeys.addressStreet]: 'Logradouro',
  [WorkOrderFieldKeys.requesterName]: 'Nome do solicitante',
  [WorkOrderFieldKeys.description]: 'Observações',
  [WorkOrderFieldKeys.addressNumber]: 'Número',
  [WorkOrderFieldKeys.ureqID]: 'Equipamento urbano',
  [WorkOrderFieldKeys.addressState]: 'Estado',
  [WorkOrderFieldKeys.requesterPhone]: 'Telefone do solicitante',
  [WorkOrderFieldKeys.wortID]: 'Tipo de solicitante',
  [WorkOrderFieldKeys.woprID]: 'Programa',
  [WorkOrderFieldKeys.wosuID]: 'Subprograma',
  [WorkOrderFieldKeys.wostID]: 'Situação',
  [WorkOrderFieldKeys.fieldAgentUsers]: 'Agentes de campo vinculados',
};

export function getOperationsFormFieldsLabel(
  form: string,
  field: string,
  alt?: string
): string {
  if (form === undefined || form === null) {
    return alt ?? '';
  }
  return (
    (
      {
        [OperationsForms.Incident]: IncidentFields,
        [OperationsForms.WorkOrder]: WorkOrderFields,
      } as any
    )?.[form]?.[field] ??
    alt ??
    ''
  );
}

export enum AuditActions {
  Get = 'get',
  Create = 'create',
  Update = 'update',
  Delete = 'delete',
}

export function getAuditActionLabel(action: AuditActions): string {
  return (
    {
      [AuditActions.Get]: i18n.t('common:auditActions.view'),
      [AuditActions.Create]: i18n.t('common:auditActions.create'),
      [AuditActions.Update]: i18n.t('common:auditActions.update'),
      [AuditActions.Delete]: i18n.t('common:auditActions.delete'),
    }[action] ?? action
  );
}

export function getAuditActionNames(key: string, alt?: string): string {
  return getAuditActionLabel(key as AuditActions) ?? alt ?? key;
}

export enum Resources {
  UserInformation = 'UserInformation',
  BudgetSource = 'BudgetSource',
  BusinessMetric = 'BusinessMetricView',
  CustomKPI = 'CustomKPIView',
  Plan = 'Plan',
  PlanDashboard = 'PlanDashboard',
  PlanSummary = 'PlanSummary',
  PlanTaskSummary = 'PlanTaskSummary',
  PlanNextTask = 'PlanNextTask',
  PlanBudgetSummary = 'PlanBudgetSummary',
  PlanLatestComments = 'PlanLatestComments',
  DocumentTemplate = 'DocumentTemplate',
  Document = 'Document',
  ThematicAxis = 'ThematicAxis',
  Institution = 'Institution',
  InstitutionUser = 'InstitutionUserView',
  BusinessUnit = 'BusinessUnit',
  Survey = 'Survey',
  SurveyResponse = 'SurveyResponse',
  SurveyResponseListing = 'SurveyResponseListing',
  SurveyFormTemplate = 'SurveyFormTemplate',
  SurveyResponseSession = 'SurveyResponseSession',
  MySurvey = 'MySurvey',
  DashboardSurvey = 'DashboardSurvey',
  DashboardIncidentNeighborhood = 'DashboardIncidentNeighborhood',
  DashboardIncidentsByNature = 'DashboardIncidentsByNature',
  DashboardIncidents = 'DashboardIncidents',
  DashboardWorkOrder = 'DashboardWorkOrder',
  DashboardWorkOrderByStatus = 'DashboardWorkOrderByStatus',
  DashboardWorkOrderByProgram = 'DashboardWorkOrderByProgram',
  Program = 'ProgramView',
  ProgramMain = 'Program',
  ProgramStatusHistory = 'ProgramStatusHistory',
  ProgramPeriodHistory = 'ProgramPeriodHistory',
  ProgramBudgetHistory = 'ProgramBudgetHistory',
  ProgramFinalBudget = 'ProgramFinalBudget',
  Project = 'ProjectView',
  ProjectMain = 'Project',
  ProjectStatusHistory = 'ProjectStatusHistory',
  ProjectPeriodHistory = 'ProjectPeriodHistory',
  ProjectBudgetHistory = 'ProjectBudgetHistory',
  ProjectFinalBudget = 'ProjectFinalBudget',
  ActionPlan = 'ActionPlanView',
  ActionPlanMain = 'ActionPlan',
  ActionPlanStatusHistory = 'ActionPlanStatusHistory',
  ActionPlanPeriodHistory = 'ActionPlanPeriodHistory',
  ActionPlanBudgetHistory = 'ActionPlanBudgetHistory',
  ActionPlanComment = 'ActionPlanCommentView',
  Action = 'ActionView',
  ActionStatusHistory = 'ActionStatusHistory',
  ActionPeriodHistory = 'ActionPeriodHistory',
  ActionComment = 'ActionCommentView',
  IncidentNature = 'IncidentNatureView',
  Incident = 'IncidentView',
  IncidentProgram = 'IncidentProgramView',
  IncidentSubprogram = 'IncidentSubprogramView',
  Guiche = 'GuicheView',
  IncidentStatus = 'IncidentStatus',
  FleetVehicle = 'FleetVehicleView',
  DispatchNature = 'DispatchNatureView',
  DispatchSubnature = 'DispatchSubnatureView',
  WorkOrderClassification = 'WorkOrderClassificationView',
  IncidentOrigin = 'IncidentOriginView',
  DispatchUnit = 'DispatchUnitView',
  IncidentDispatcher = 'IncidentDispatcherView',
  UrbanEquipment = 'UrbanEquipmentView',
  IncidentActionType = 'IncidentActionTypeView',
  ServiceChannel = 'ServiceChannelView',
  RequestingCompany = 'RequestingCompanyView',
  DispatchStatus = 'DispatchStatusView',
  WorkOrderRequesterType = 'WorkOrderRequesterTypeView',
  IncidentSubnature = 'IncidentSubnatureView',
  ApplicationRole = 'ApplicationRole',
  UserRole = 'UserRoleView',
  IncidentEnvironment = 'IncidentEnvironmentView',
  WorkOrderProgram = 'WorkOrderProgramView',
  WorkOrderSubprogram = 'WorkOrderSubprogramView',
  WorkOrderRequesterFunction = 'WorkOrderRequesterFunctionView',
  WorkOrderStatus = 'WorkOrderStatusView',
  IncidentDocument = 'IncidentDocumentView',
  WorkOrder = 'WorkOrderView',
  WorkOrderDocument = 'WorkOrderDocumentView',
  PhysicalCondition = 'PhysicalConditionView',
  PublicEquipment = 'PublicEquipmentView',
  VulnerablePopulation = 'VulnerablePopulationView',
  IncidentEstablishment = 'IncidentEstablishmentView',
  IncidentResponseLocation = 'IncidentResponseLocationView',
  FormValidation = 'FormValidationView',
  FormDocumentTemplate = 'FormDocumentTemplateView',
}

export const ResourceNames = {
  [Resources.UserInformation]: 'Informação do Usuário',
  [Resources.BudgetSource]: 'Fonte de Orçamento',
  [Resources.BusinessMetric]: 'Métrica de Negócio',
  [Resources.CustomKPI]: 'KPI Personalizado',
  [Resources.Plan]: 'Plano',
  [Resources.PlanDashboard]: 'Dashboard do Plano',
  [Resources.PlanSummary]: 'Resumo do Plano',
  [Resources.PlanTaskSummary]: 'Resumo das Tarefas do Plano',
  [Resources.PlanNextTask]: 'Próxima Tarefa do Plano',
  [Resources.PlanBudgetSummary]: 'Resumo do Orçamento do Plano',
  [Resources.PlanLatestComments]: 'Últimos Comentários do Plano',
  [Resources.DocumentTemplate]: 'Modelo de Documento',
  [Resources.Document]: 'Documento',
  [Resources.ThematicAxis]: 'Eixo Estratégico',
  [Resources.Institution]: 'Instituição',
  [Resources.InstitutionUser]: 'Usuário da Instituição',
  [Resources.BusinessUnit]: 'Unidade de Negócio',
  [Resources.Survey]: 'Pesquisa',
  [Resources.SurveyResponse]: 'Resposta da Pesquisa',
  [Resources.SurveyResponseListing]: 'Listagem de Respostas da Pesquisa',
  [Resources.SurveyFormTemplate]: 'Modelo de Formulário de Pesquisa',
  [Resources.SurveyResponseSession]: 'Sessão de Resposta da Pesquisa',
  [Resources.MySurvey]: 'Minha Pesquisa',
  [Resources.DashboardSurvey]: 'Dashboard da Pesquisa',
  [Resources.DashboardIncidentNeighborhood]:
    'Dashboard de Incidentes por Bairro',
  [Resources.DashboardIncidentsByNature]:
    'Dashboard de Incidentes por Natureza',
  [Resources.DashboardIncidents]: 'Dashboard de Incidentes',
  [Resources.DashboardWorkOrder]: 'Dashboard de Ordens de Serviço',
  [Resources.DashboardWorkOrderByStatus]:
    'Dashboard de Ordens de Serviço por Status',
  [Resources.DashboardWorkOrderByProgram]:
    'Dashboard de Ordens de Serviço por Programa',
  [Resources.Program]: 'Programa',
  [Resources.ProgramMain]: 'Programa Principal',
  [Resources.ProgramStatusHistory]: 'Histórico de Status do Programa',
  [Resources.ProgramPeriodHistory]: 'Histórico de Períodos do Programa',
  [Resources.ProgramBudgetHistory]: 'Histórico de Orçamento do Programa',
  [Resources.ProgramFinalBudget]: 'Orçamento liquidado do Programa',
  [Resources.Project]: 'Linha de Ação',
  [Resources.ProjectMain]: 'Linha de Ação Principal',
  [Resources.ProjectStatusHistory]: 'Histórico de Status da Linha de Ação',
  [Resources.ProjectPeriodHistory]: 'Histórico de Períodos da Linha de Ação',
  [Resources.ProjectBudgetHistory]: 'Histórico de Orçamento da Linha de Ação',
  [Resources.ProjectFinalBudget]: 'Orçamento liquidado da Linha de Ação',
  [Resources.ActionPlan]: 'Iniciativa',
  [Resources.ActionPlanMain]: 'Iniciativa Principal',
  [Resources.ActionPlanStatusHistory]: 'Histórico de Status da Iniciativa',
  [Resources.ActionPlanPeriodHistory]: 'Histórico de Períodos da Iniciativa',
  [Resources.ActionPlanBudgetHistory]: 'Histórico de Orçamento da Iniciativa',
  [Resources.ActionPlanComment]: 'Comentário da Iniciativa',
  [Resources.Action]: 'Ação',
  [Resources.ActionStatusHistory]: 'Histórico de Status da Ação',
  [Resources.ActionPeriodHistory]: 'Histórico de Períodos da Ação',
  [Resources.ActionComment]: 'Comentário da Ação',
  [Resources.IncidentNature]: 'Natureza do Incidente',
  [Resources.IncidentProgram]: 'Programa do Incidente',
  [Resources.IncidentSubprogram]: 'Subprograma do Incidente',
  [Resources.Guiche]: 'Guichê',
  [Resources.IncidentStatus]: 'Status do Incidente',
  [Resources.FleetVehicle]: 'Veículo da Frota',
  [Resources.DispatchNature]: 'Natureza do Despacho',
  [Resources.DispatchSubnature]: 'Subnatureza do Despacho',
  [Resources.WorkOrderClassification]: 'Classificação da Ordem de Serviço',
  [Resources.IncidentOrigin]: 'Origem do Incidente',
  [Resources.DispatchUnit]: 'Unidade de Despacho',
  [Resources.IncidentDispatcher]: 'Despachante do Incidente',
  [Resources.UrbanEquipment]: 'Equipamento Urbano',
  [Resources.IncidentActionType]: 'Tipo de Ação do Incidente',
  [Resources.ServiceChannel]: 'Canal de Serviço',
  [Resources.RequestingCompany]: 'Empresa Solicitante',
  [Resources.DispatchStatus]: 'Status do Despacho',
  [Resources.WorkOrderRequesterType]: 'Tipo de Solicitante da Ordem de Serviço',
  [Resources.Incident]: 'Atendimento',
  [Resources.IncidentSubnature]: 'Subnatureza do Incidente',
  [Resources.ApplicationRole]: 'Função do Aplicativo',
  [Resources.UserRole]: 'Função do Usuário',
  [Resources.IncidentEnvironment]: 'Ambiente do Incidente',
  [Resources.WorkOrderProgram]: 'Programa da Ordem de Serviço',
  [Resources.WorkOrderSubprogram]: 'Subprograma da Ordem de Serviço',
  [Resources.WorkOrderRequesterFunction]:
    'Função do Solicitante da Ordem de Serviço',
  [Resources.WorkOrderStatus]: 'Status da Ordem de Serviço',
  [Resources.IncidentDocument]: 'Documento do Incidente',
  [Resources.WorkOrder]: 'Ordem de Serviço',
  [Resources.WorkOrderDocument]: 'Documento da Ordem de Serviço',
  [Resources.PhysicalCondition]: 'Condição Física',
  [Resources.PublicEquipment]: 'Equipamento Público',
  [Resources.VulnerablePopulation]: 'População Vulnerável',
  [Resources.IncidentEstablishment]: 'Estabelecimento do Incidente',
  [Resources.IncidentResponseLocation]: 'Local de Resposta ao Incidente',
  [Resources.FormValidation]: 'Validação de Formulário',
  [Resources.FormDocumentTemplate]: 'Modelo de Documento do Formulário',
};

export function getResourceNames(key: string, alt?: string): string {
  return (ResourceNames as any)?.[key] ?? alt ?? key;
}

export enum SystemFields {
  userID = 'userID',
  applID = 'applID',
  busoID = 'busoID',
  bumeID = 'bumeID',
  planID = 'planID',
  cukpID = 'cukpID',
  inusID = 'inusID',
  actiID = 'actiID',
  acplID = 'acplID',
  doteID = 'doteID',
  docuID = 'docuID',
  thaxID = 'thaxID',
  instID = 'instID',
  buunID = 'buunID',
  survID = 'survID',
  sureID = 'sureID',
  sursID = 'sursID',
  suftID = 'suftID',
  innaID = 'innaID',
  wostID = 'wostID',
  woprID = 'woprID',
  progID = 'progID',
  prpeID = 'prpeID',
  oppeID = 'oppeID',
  projID = 'projID',
  commID = 'commID',
  acpeID = 'acpeID',
  inprID = 'inprID',
  insuID = 'insuID',
  guicID = 'guicID',
  istaID = 'istaID',
  flveID = 'flveID',
  dinaID = 'dinaID',
  disuID = 'disuID',
  woclID = 'woclID',
  inorID = 'inorID',
  diunID = 'diunID',
  indiID = 'indiID',
  ureqID = 'ureqID',
  iatyID = 'iatyID',
  sechID = 'sechID',
  recoID = 'recoID',
  distID = 'distID',
  wortID = 'wortID',
  inbnID = 'inbnID',
  aproID = 'aproID',
  inenID = 'inenID',
  wosuID = 'wosuID',
  worfID = 'worfID',
  inciID = 'inciID',
  infdID = 'infdID',
  woorID = 'woorID',
  wodoID = 'wodoID',
  phcoID = 'phcoID',
  pueqID = 'pueqID',
  vupoID = 'vupoID',
  inesID = 'inesID',
  irloID = 'irloID',
  fovaID = 'fovaID',
  fodtID = 'fodtID',
  survIDs = 'survIDs',
  clientUID = 'clientUID',
  name = 'name',
  pushTokens = 'pushTokens',
  info = 'info',
  createdAt = 'createdAt',
  deletedAt = 'deletedAt',
  authenticationProvider = 'authenticationProvider',
  email = 'email',
  roles = 'roles',
  userInstitutions = 'userInstitutions',
  description = 'description',
  status = 'status',
  rule = 'rule',
  thematicAxisInfo = 'thematicAxisInfo',
  projectInfo = 'projectInfo',
  kpiProgress = 'kpiProgress',
  updatedAt = 'updatedAt',
  values = 'values',
  totalReceived = 'totalReceived',
  totalPredicted = 'totalPredicted',
  totalActual = 'totalActual',
  budgetSourceName = 'budgetSourceName',
  resourceTimeline = 'resourceTimeline',
  resourceSummary = 'resourceSummary',
  openTasks = 'openTasks',
  finishedTasks = 'finishedTasks',
  finishedPercentage = 'finishedPercentage',
  finishDate = 'finishDate',
  budgetSummary = 'budgetSummary',
  percentageUsage = 'percentageUsage',
  avatar = 'avatar',
  message = 'message',
  title = 'title',
  formSchema = 'formSchema',
  uiSchema = 'uiSchema',
  defaultData = 'defaultData',
  printSchema = 'printSchema',
  permissionMode = 'permissionMode',
  data = 'data',
  documentType = 'documentType',
  documentNumber = 'documentNumber',
  abbreviation = 'abbreviation',
  code = 'code',
  operationalCode = 'operationalCode',
  phone = 'phone',
  sex = 'sex',
  slug = 'slug',
  descriptionFinished = 'descriptionFinished',
  displayOptions = 'displayOptions',
  surveyForms = 'surveyForms',
  allowedUsers = 'allowedUsers',
  answers = 'answers',
  drafts = 'drafts',
  clientIP = 'clientIP',
  clientDevice = 'clientDevice',
  metadata = 'metadata',
  submittedAt = 'submittedAt',
  responses = 'responses',
  pools = 'pools',
  totalAnswers = 'totalAnswers',
  neighborhood = 'neighborhood',
  total = 'total',
  serviceIncidents = 'serviceIncidents',
  securityIncidents = 'securityIncidents',
  natureName = 'natureName',
  incidentProgression = 'incidentProgression',
  averageResponseTime = 'averageResponseTime',
  averagePerYear = 'averagePerYear',
  MonthTotal = 'MonthTotal',
  YearTotal = 'YearTotal',
  statusInfo = 'statusInfo',
  workOrders = 'workOrders',
  programName = 'programName',
  content = 'content',
  axes = 'axes',
  institutions = 'institutions',
  budgets = 'budgets',
  period = 'period',
  projectCount = 'projectCount',
  institutionUserName = 'institutionUserName',
  programUsers = 'programUsers',
  userName = 'userName',
  startAt = 'startAt',
  endAt = 'endAt',
  actionPlanCount = 'actionPlanCount',
  projectUsers = 'projectUsers',
  attachment = 'attachment',
  actionCount = 'actionCount',
  actionPlanUsers = 'actionPlanUsers',
  comments = 'comments',
  statusMessage = 'statusMessage',
  statusAttachment = 'statusAttachment',
  details = 'details',
  registrationNumber = 'registrationNumber',
  licensePlate = 'licensePlate',
  make = 'make',
  model = 'model',
  year = 'year',
  uid = 'uid',
  incidentType = 'incidentType',
  fieldContact = 'fieldContact',
  servicedAt = 'servicedAt',
  arrivalAt = 'arrivalAt',
  incidentVehicles = 'incidentVehicles',
  seizedItems = 'seizedItems',
  actionTypeName = 'actionTypeName',
  institutionName = 'institutionName',
  publicEquipmentName = 'publicEquipmentName',
  partnerInstitutionName = 'partnerInstitutionName',
  originName = 'originName',
  dispatcherName = 'dispatcherName',
  dispatchUnit = 'dispatchUnit',
  dispatchStatus = 'dispatchStatus',
  dispatchNature = 'dispatchNature',
  dispatchSubnature = 'dispatchSubnature',
  subnatureName = 'subnatureName',
  subprogramName = 'subprogramName',
  statusName = 'statusName',
  environmentName = 'environmentName',
  establishmentName = 'establishmentName',
  agentName = 'agentName',
  relatorName = 'relatorName',
  relatorCode = 'relatorCode',
  serviceChannelName = 'serviceChannelName',
  guicheName = 'guicheName',
  involvedParties = 'involvedParties',
  event = 'event',
  generalEffective = 'generalEffective',
  ordinaryEffective = 'ordinaryEffective',
  extraordinaryEffective = 'extraordinaryEffective',
  planningIdentifier = 'planningIdentifier',
  address = 'address',
  requester = 'requester',
  requesterRole = 'requesterRole',
  requesterType = 'requesterType',
  urbanEquipmentName = 'urbanEquipmentName',
  requesterCompanyName = 'requesterCompanyName',
  classification = 'classification',
  fieldAgents = 'fieldAgents',
  formName = 'formName',
  validationSchema = 'validationSchema',
  activeAt = 'activeAt',
  departedAt = 'departedAt',
  returnedAt = 'returnedAt',
  responsibleName = 'responsibleName',
  city = 'city',
  state = 'state',
  number = 'number',
  street = 'street',
  zipCode = 'zipCode',
  isVillage = 'isVillage',
  complement = 'complement',
  actual = 'actual',
  backgroundColor = 'backgroundColor',
}

export const SystemFieldNames = {
  [SystemFields.userID]: 'ID de usuário',
  [SystemFields.applID]: 'ID da aplicação',
  [SystemFields.busoID]: 'ID de fonte de orçamento',
  [SystemFields.bumeID]: 'ID da Meta',
  [SystemFields.planID]: 'ID do plano',
  [SystemFields.cukpID]: 'ID do indicador',
  [SystemFields.inusID]: 'ID de usuário do órgão',
  [SystemFields.actiID]: 'ID da atividade',
  [SystemFields.acplID]: 'ID da iniciativa',
  [SystemFields.doteID]: 'ID de formulário customizado',
  [SystemFields.docuID]: 'ID do documento',
  [SystemFields.thaxID]: 'ID do eixo estratégico',
  [SystemFields.instID]: 'ID do órgão',
  [SystemFields.buunID]: 'ID da unidade administrativa',
  [SystemFields.survID]: 'ID da pesquisa',
  [SystemFields.sureID]: 'ID de resposta da pesquisa',
  [SystemFields.sursID]: 'ID de sessão de resposta à pesquisa',
  [SystemFields.suftID]: 'ID de modelo de formulário de pesquisa',
  [SystemFields.innaID]: 'ID de natureza do atendimento',
  [SystemFields.wostID]: 'ID de status da O.S',
  [SystemFields.woprID]: 'ID de programa de O.S',
  [SystemFields.progID]: 'ID do programa',
  [SystemFields.prpeID]: 'ID do período do programa',
  [SystemFields.oppeID]: 'ID do período operacional',
  [SystemFields.projID]: 'ID da linha de ação',
  [SystemFields.commID]: 'ID do comentário',
  [SystemFields.acpeID]: 'ID de período de ação',
  [SystemFields.inprID]: 'ID de programa do atendimento',
  [SystemFields.insuID]: 'ID de subprograma do atendimento',
  [SystemFields.guicID]: 'ID do guiche',
  [SystemFields.istaID]: 'ID do status do atendimento',
  [SystemFields.flveID]: 'ID de veículos da frota',
  [SystemFields.dinaID]: 'ID da natureza do despacho',
  [SystemFields.disuID]: 'ID da subnatureza do Despacho',
  [SystemFields.woclID]: 'ID de classificação da O.S',
  [SystemFields.inorID]: 'ID de origem do atendimento',
  [SystemFields.diunID]: 'ID de unidade de despacho',
  [SystemFields.indiID]: 'ID do despacho de atendimento',
  [SystemFields.ureqID]: 'ID do equipamento urbano',
  [SystemFields.iatyID]: 'ID do tipo de ação do atendimento',
  [SystemFields.sechID]: 'ID do canal de atendimento',
  [SystemFields.recoID]: 'ID da empresa solicitante',
  [SystemFields.distID]: 'ID do status do Despacho',
  [SystemFields.wortID]: 'ID de tipo de solicitante da O.S',
  [SystemFields.inbnID]: 'ID de subnatureza do atendimento',
  [SystemFields.aproID]: 'ID de permissão',
  [SystemFields.inenID]: 'ID de ambiente do atendiemnto',
  [SystemFields.wosuID]: 'ID de subprograma da O.S',
  [SystemFields.worfID]: 'ID da função do solicitante da O.S',
  [SystemFields.inciID]: 'ID do atendimento',
  [SystemFields.infdID]: 'ID do documento do atendimento',
  [SystemFields.woorID]: 'ID da ordem de serviço',
  [SystemFields.wodoID]: 'ID do documento da O.S',
  [SystemFields.phcoID]: 'ID da condição física',
  [SystemFields.pueqID]: 'ID do equipamento público',
  [SystemFields.vupoID]: 'ID de população vulnerável',
  [SystemFields.inesID]: 'ID de estabelecimento do atendimento',
  [SystemFields.irloID]: 'ID de local de resposta ao incidente',
  [SystemFields.fovaID]: 'ID de validação de formulário',
  [SystemFields.fodtID]: 'ID de modelo de documento do formulário',
  [SystemFields.survIDs]: 'ID das pesquisas',
  [SystemFields.clientUID]: 'Identificador do Dispositivo',
  [SystemFields.name]: 'Nome',
  [SystemFields.pushTokens]: 'Tokens De Notificação',
  [SystemFields.info]: 'Informações',
  [SystemFields.createdAt]: 'Criado Em',
  [SystemFields.deletedAt]: 'Deletado Em',
  [SystemFields.authenticationProvider]: 'Provedor De Autenticação',
  [SystemFields.email]: 'Email',
  [SystemFields.roles]: 'Papéis',
  [SystemFields.userInstitutions]: 'Instituições Do Usuário',
  [SystemFields.description]: 'Descrição',
  [SystemFields.status]: 'Status',
  [SystemFields.rule]: 'Regra',
  [SystemFields.thematicAxisInfo]: 'Informações Do Eixo Estratégico',
  [SystemFields.projectInfo]: 'Informações Da Linha de Ação',
  [SystemFields.kpiProgress]: 'Progresso Do KPI',
  [SystemFields.updatedAt]: 'Atualizado Em',
  [SystemFields.values]: 'Valores',
  [SystemFields.totalReceived]: 'Total Empenhado',
  [SystemFields.totalPredicted]: 'Total Previsto',
  [SystemFields.totalActual]: 'Total Real',
  [SystemFields.budgetSourceName]: 'Nome Da Fonte Orçamentária',
  [SystemFields.resourceTimeline]: 'Linha Do Tempo Dos Recursos',
  [SystemFields.resourceSummary]: 'Resumo Dos Recursos',
  [SystemFields.openTasks]: 'Tarefas Abertas',
  [SystemFields.finishedTasks]: 'Tarefas Concluídas',
  [SystemFields.finishedPercentage]: 'Porcentagem Concluída',
  [SystemFields.finishDate]: 'Data De Conclusão',
  [SystemFields.budgetSummary]: 'Resumo Orçamentário',
  [SystemFields.percentageUsage]: 'Percentual De Uso',
  [SystemFields.avatar]: 'Avatar',
  [SystemFields.message]: 'Mensagem',
  [SystemFields.title]: 'Título',
  [SystemFields.formSchema]: 'Esquema Do Formulário',
  [SystemFields.uiSchema]: 'Esquema Da Interface',
  [SystemFields.defaultData]: 'Dados Padrão',
  [SystemFields.printSchema]: 'Esquema De Impressão',
  [SystemFields.permissionMode]: 'Modo De Permissão',
  [SystemFields.data]: 'Dados',
  [SystemFields.documentType]: 'Tipo De Documento',
  [SystemFields.documentNumber]: 'Número Do Documento',
  [SystemFields.abbreviation]: 'Abreviação',
  [SystemFields.code]: 'Código',
  [SystemFields.operationalCode]: 'Código Operacional',
  [SystemFields.phone]: 'Telefone',
  [SystemFields.sex]: 'Sexo',
  [SystemFields.slug]: 'Slug',
  [SystemFields.descriptionFinished]: 'Descrição Concluída',
  [SystemFields.displayOptions]: 'Opções De Exibição',
  [SystemFields.surveyForms]: 'Formulários De Pesquisa',
  [SystemFields.allowedUsers]: 'Usuários Permitidos',
  [SystemFields.answers]: 'Respostas',
  [SystemFields.drafts]: 'Rascunhos',
  [SystemFields.clientIP]: 'IP Do Cliente',
  [SystemFields.clientDevice]: 'Dispositivo Do Cliente',
  [SystemFields.metadata]: 'Metadados',
  [SystemFields.submittedAt]: 'Enviado Em',
  [SystemFields.responses]: 'Respostas',
  [SystemFields.pools]: 'Padrões',
  [SystemFields.totalAnswers]: 'Total De Respostas',
  [SystemFields.neighborhood]: 'Bairro',
  [SystemFields.total]: 'Total',
  [SystemFields.serviceIncidents]: 'Incidentes De Serviço',
  [SystemFields.securityIncidents]: 'Incidentes De Segurança',
  [SystemFields.natureName]: 'Nome Da Natureza',
  [SystemFields.incidentProgression]: 'Progressão Do Incidente',
  [SystemFields.averageResponseTime]: 'Tempo Médio De Resposta',
  [SystemFields.averagePerYear]: 'Média Por Ano',
  [SystemFields.MonthTotal]: 'Total Do Mês',
  [SystemFields.YearTotal]: 'Total Do Ano',
  [SystemFields.statusInfo]: 'Informações De Status',
  [SystemFields.workOrders]: 'Ordens De Serviço',
  [SystemFields.programName]: 'Nome Do Programa',
  [SystemFields.content]: 'Conteúdo',
  [SystemFields.axes]: 'Eixos',
  [SystemFields.institutions]: 'Instituições',
  [SystemFields.budgets]: 'Orçamentos',
  [SystemFields.period]: 'Período',
  [SystemFields.projectCount]: 'Contagem De Linhas de Ação',
  [SystemFields.institutionUserName]: 'Nome Do Usuário Da Instituição',
  [SystemFields.programUsers]: 'Usuários Do Programa',
  [SystemFields.userName]: 'Nome Do Usuário',
  [SystemFields.startAt]: 'Início Em',
  [SystemFields.endAt]: 'Término Em',
  [SystemFields.actionPlanCount]: 'Contagem De Iniciativas',
  [SystemFields.projectUsers]: 'Usuários Da Linha de Ação',
  [SystemFields.attachment]: 'Anexo',
  [SystemFields.actionCount]: 'Contagem De Ações',
  [SystemFields.actionPlanUsers]: 'Usuários Da Iniciativa',
  [SystemFields.comments]: 'Comentários',
  [SystemFields.statusMessage]: 'Mensagem De Status',
  [SystemFields.statusAttachment]: 'Anexo De Status',
  [SystemFields.details]: 'Detalhes',
  [SystemFields.registrationNumber]: 'Número De Registro',
  [SystemFields.licensePlate]: 'Placa Do Veículo',
  [SystemFields.make]: 'Marca',
  [SystemFields.model]: 'Modelo',
  [SystemFields.year]: 'Ano',
  [SystemFields.uid]: 'N° do protocolo',
  [SystemFields.incidentType]: 'Tipo De Incidente',
  [SystemFields.fieldContact]: 'Contato Em Campo',
  [SystemFields.servicedAt]: 'Atendido Em',
  [SystemFields.arrivalAt]: 'Chegada Em',
  [SystemFields.incidentVehicles]: 'Veículos Envolvidos No Incidente',
  [SystemFields.seizedItems]: 'Itens Apreendidos',
  [SystemFields.actionTypeName]: 'Nome Do Tipo De Ação',
  [SystemFields.institutionName]: 'Nome Da Instituição',
  [SystemFields.publicEquipmentName]: 'Nome Do Equipamento Público',
  [SystemFields.partnerInstitutionName]: 'Nome Da Instituição Parceira',
  [SystemFields.originName]: 'Nome Da Origem',
  [SystemFields.dispatcherName]: 'Nome Do Despachante',
  [SystemFields.dispatchUnit]: 'Unidade De Despacho',
  [SystemFields.dispatchStatus]: 'Status De Despacho',
  [SystemFields.dispatchNature]: 'Natureza Do Despacho',
  [SystemFields.dispatchSubnature]: 'Subnatureza Do Despacho',
  [SystemFields.subnatureName]: 'Nome Da Subnatureza',
  [SystemFields.subprogramName]: 'Nome Do Subprograma',
  [SystemFields.statusName]: 'Nome Do Status',
  [SystemFields.environmentName]: 'Nome Do Ambiente',
  [SystemFields.establishmentName]: 'Nome Do Estabelecimento',
  [SystemFields.agentName]: 'Nome Do Agente',
  [SystemFields.relatorName]: 'Nome Do Relator',
  [SystemFields.relatorCode]: 'Código Do Relator',
  [SystemFields.serviceChannelName]: 'Nome do canal de atendimento',
  [SystemFields.guicheName]: 'Nome Do Guichê',
  [SystemFields.involvedParties]: 'Partes Envolvidas',
  [SystemFields.event]: 'Evento',
  [SystemFields.generalEffective]: 'Efetivo Geral',
  [SystemFields.ordinaryEffective]: 'Efetivo Ordinário',
  [SystemFields.extraordinaryEffective]: 'Efetivo Extraordinário',
  [SystemFields.planningIdentifier]: 'Identificador Do Planejamento',
  [SystemFields.address]: 'Endereço',
  [SystemFields.requester]: 'Solicitante',
  [SystemFields.requesterRole]: 'Papel Do Solicitante',
  [SystemFields.requesterType]: 'Tipo De Solicitante',
  [SystemFields.urbanEquipmentName]: 'Nome Do Equipamento Urbano',
  [SystemFields.requesterCompanyName]: 'Nome Da Empresa Do Solicitante',
  [SystemFields.classification]: 'Classificação',
  [SystemFields.fieldAgents]: 'Agentes De Campo',
  [SystemFields.formName]: 'Nome Do Formulário',
  [SystemFields.validationSchema]: 'Esquema De Validação',
  [SystemFields.activeAt]: 'Data de ativação',
  [SystemFields.departedAt]: 'Data e hora de saída',
  [SystemFields.returnedAt]: 'Data e hora de retorno',
  [SystemFields.responsibleName]: 'Nome do responsavel',
  [SystemFields.city]: 'Cidade',
  [SystemFields.state]: 'Estado',
  [SystemFields.number]: 'Número',
  [SystemFields.street]: 'Rua',
  [SystemFields.zipCode]: 'CEP',
  [SystemFields.isVillage]: 'Vila ou Invasão?',
  [SystemFields.complement]: 'Complemento',
  [SystemFields.actual]: 'Atual',
  [SystemFields.backgroundColor]: 'Tema do plano de fundo',
};

export enum DocumentationTag {
  action = 'atividade',
  actionPlan = 'iniciativa',
  notification = 'notificação',
  audit = 'auditoria',
  budgetSource = 'fonte de orçamento',
  budgetType = 'tipo de orçamento',
  budgetResourceType = 'tipo de recurso do orçamento',
  businessMetric = 'metas',
  customKPI = 'indicador de resultado',
  defaultText = 'texto padrão',
  dispatchNature = 'natureza de despacho',
  dispatchSubnature = 'subnatureza de despacho',
  dispatchStatus = 'status de despacho',
  dispatchUnit = 'unidade de despacho',
  documentation = 'documentação',
  fleetVehicle = 'frota',
  formDocumentTemplate = 'template de formulário',
  formValidation = 'configurações de formulário',
  guiche = 'guiche',
  incident = 'atendimento',
  incidentActionType = 'tipo de atuação',
  incidentDispatcher = 'despachante',
  incidentEnvironment = 'ambiente do incidente',
  incidentEstablishment = 'estabelecimento do incidente',
  incidentNature = 'natureza do atendimento',
  incidentOrigin = 'origem do atendimento',
  incidentProgram = 'programa do atendimento',
  incidentResponseLocation = 'local de encaminhamento',
  incidentStatus = 'status do incidente',
  incidentSubnature = 'subnatureza do atendimento',
  incidentSubprogram = 'subprograma do atendimento',
  institutions = 'órgão',
  manager = 'usuário',
  mySurveys = 'minhas pesquisas',
  surveyResponses = 'respostas da pesquisa',
  physicalCondition = 'estado físico',
  plan = 'plano',
  program = 'iniciativa',
  project = 'linha de ação',
  publicEquipment = 'equipamento público',
  requestinCompany = 'empresa solicitante',
  serviceChannel = 'canal de atendimento',
  setupOperations = 'setup do sistema',
  survey = 'pesquisa',
  terms = 'termos',
  strategicAxis = 'eixo estratégico',
  urbanEquipment = 'equipamento urbano',
  vulnerablePopulation = 'população vulnerável',
  workOrder = 'ordem de serviço',
  workOrderClassification = 'classificação da o.s',
  workOrderProgram = 'programa da o.s',
  workOrderRequestFunction = 'função do solicitante da o.s',
  workOrderRequestType = 'tipo de solicitante da o.s',
  workOrderStatus = 'status da o.s',
  workOrderSubprogram = 'subprograma da o.s',
  status = 'status',
  security = 'segurança',
  businessUnit = 'unidade de negócio',
  mySurvey = 'preenchimento de pesquisa',
  managerInstitution = 'usuário órgão',
  managerSecurity = 'usuário segurança',

  create = 'criar',
  remove = 'remover',
  update = 'atualizar',
  view = 'visualizar',
  list = 'listar',
}

export function getSystemFieldNames(key: string, alt?: string): string {
  return (SystemFieldNames as any)?.[key] ?? alt ?? key;
}

export enum TaskQueueType {
  projectStatusApproval = 'project-status-approval',
  actionPlanStatusApproval = 'action-plan-status-approval',
  actionStatusApproval = 'action-status-approval',
  actionPlanBudgetApproval = 'action-plan-budget-approval',
  customKpiApproval = 'custom-kpi-approval',
  outdatedCustomKpi = 'outdated-custom-kpi',
  nearUpdateCustomKpi = 'near-update-custom-kpi',
  rejectedCustomKpi = 'rejected-custom-kpi',
  overdueAction = 'overdue-action',
  endNearAction = 'end-near-action',
}

export function getTaskQueueTypeLabel(taskType: string): string {
  return (
    {
      [TaskQueueType.projectStatusApproval]: i18n.t(
        'common:myTaskQueue.types.statusPendingApproval',
        {
          entity: i18n.t('common:entities.project'),
        }
      ),
      [TaskQueueType.actionPlanStatusApproval]: i18n.t(
        'common:myTaskQueue.types.statusPendingApproval',
        {
          entity: i18n.t('common:entities.actionPlan'),
        }
      ),
      [TaskQueueType.actionStatusApproval]: i18n.t(
        'common:myTaskQueue.types.statusPendingApproval',
        {
          entity: i18n.t('common:entities.action'),
        }
      ),
      [TaskQueueType.actionPlanBudgetApproval]: i18n.t(
        'common:myTaskQueue.types.budgetApproval',
        {
          entity: i18n.t('common:entities.actionPlan'),
        }
      ),
      [TaskQueueType.customKpiApproval]: i18n.t(
        'common:myTaskQueue.types.customKpiApproval'
      ),
      [TaskQueueType.outdatedCustomKpi]: i18n.t(
        'common:myTaskQueue.types.outdatedCustomKpi'
      ),
      [TaskQueueType.nearUpdateCustomKpi]: i18n.t(
        'common:myTaskQueue.types.nearUpdateCustomKpi'
      ),
      [TaskQueueType.rejectedCustomKpi]: i18n.t(
        'common:myTaskQueue.types.rejectedCustomKpi'
      ),
      [TaskQueueType.overdueAction]: i18n.t(
        'common:myTaskQueue.types.overdueAction'
      ),
      [TaskQueueType.endNearAction]: i18n.t(
        'common:myTaskQueue.types.endNearAction'
      ),
    }[taskType] ?? taskType
  );
}

export enum StatusWorkItemType {
  Program = 'program',
  Project = 'project',
  ActionPlan = 'action_plan',
  Action = 'action',
  Milestone = 'milestone',
}

export const StatusWorkItemTypeOptions = [
  {
    label: (i18n.t as any)('common:entities.program'),
    value: StatusWorkItemType.Program,
  },
  {
    label: (i18n.t as any)('common:entities.project'),
    value: StatusWorkItemType.Project,
  },
  {
    label: (i18n.t as any)('common:entities.actionPlan'),
    value: StatusWorkItemType.ActionPlan,
  },
  {
    label: (i18n.t as any)('common:fields.action'),
    value: StatusWorkItemType.Action,
  },
  {
    label: (i18n.t as any)('common:fields.milestone'),
    value: StatusWorkItemType.Milestone,
  },
];
